import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {Box, Tab, Tabs, AppBar, makeStyles, Typography} from '@material-ui/core';
import { CheckCircleOutline, LibraryAdd, Assignment, HighlightOff } from '@material-ui/icons';
//PAGINAS
import Title from 'components/TitleWithIcon';
import DialogLoadingMessage from 'components/LoadingMessage/index'
import ListadoDeSolicitudesNuevas from './SolicitudesNuevas/index';
import ListadoDeSolicitudesAprobadas from './SolicitudesEnviadas'
import ListadoDeSolicitudesTSEVirtual from './SolicitudesTSEVirtual'
import ListadoDeSolicitudesRechazadas from './SolicitudesRechazadas';
import ListadoDeSolicitudesCasosEspeciales from './SolicitudesCasosEspeciales'
import ListadoDesolicitudesReportadosAInformaticaInconsistencias from './SolicitudesConInconsistencias'
//REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import ApiServices from 'services/ApiServices';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`} {...other}
        >
            {value === index && (
                <Box p={3} style={{padding: '0px 0px 10px 0px'}}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        textAlign: 'center',
        padding: '0px',
    },
    backgroundColorTab:{
        backgroundColor: '#D4D8E1',
        padding: '0px',
    },
    contenedorTotalDeSolicitudes:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        backgroundColor: '#EDEDED',
    },
    contenedorPorSeccion: {
        border: '1px solid #1F558C',
        borderRadius: '10px',
        padding: '5px',
        margin: '5px',
        backgroundColor: '#2179d3',
        color: 'white',
    }
}));

function ScrollableTabsButtonForce(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(props.tabValueInitial);
    const [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});
    const [totalSolicitudesPendientes, setTotalSolicitudesPendientes] = useState([])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    var authenticated =props.authenticated;
    useEffect(() => {
        if(props.idSolicitudTSEVirtualEnviada){
            handleChange({},4)
        }
    },[props.idSolicitudTSEVirtualEnviada])

    const FuncionObtenerInformacion = (response) =>{
        let getData = response
        let code = '', saveData = [];
        for (let index = 0; index < getData.length; index++) {
            code = getData[index].origen.split('-')
            if(code[0] === '3')
                saveData.push({code: code[0], total: getData[index].cantidad, title: code[1]})
            else if(code[0] === '4')
                saveData.push({code: code[0], total: getData[index].cantidad, title: code[1]})
            else if(code[0] === '6')
                saveData.push({code: code[0], total: getData[index].cantidad, title: code[1]})
            else if(code[0] === '7')
                saveData.push({code: code[0], total: getData[index].cantidad, title: code[1]})
        }
        setTotalSolicitudesPendientes(saveData)
    }

    const ObtenerTotalDeSolicitudesPendientesDeRealizar = async () => {
        // setLoadingMessage({loading: true, title:'Calculando solicitudes pendientes de realizar ...'})
        // try {
        //     let response = await ApiServices.contadorSolicitudes.listRegister()
        //     if(response.error!==null){
        //         showMessagePersonalizedPosition('error','¡Advertencia!', response.error,'center')
        //     }
        //     else{
        //         FuncionObtenerInformacion(response.data)
        //     }
        // } catch (exception) {
        //     showMessagePersonalizedPosition('error', '¡Advertencia! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
        // }  
        // setLoadingMessage({loading: false, title:''})
    };

    useEffect(()=>{
        if (props.currentUser?.rol_id === 11 || props.currentUser?.rol_id === 14){
            return;
        }else{
            ObtenerTotalDeSolicitudesPendientesDeRealizar()
        }
    },[])

    return (
        <div className={classes.root}>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <Title title="Gestiones de Empadronamiento" icon={"/menu/Document.png"}/>
            {
                (props.currentUser?.rol_id === 11 || props.currentUser?.rol_id === 14) ?
                    ''
                :
                    <Typography variant="subtitle2" gutterBottom>Solicitudes pendientes de procesar:</Typography>
            }
            <div className={classes.contenedorTotalDeSolicitudes}>
                {
                    totalSolicitudesPendientes.length > 0 && (
                        totalSolicitudesPendientes.map((label, index) => (
                            <>
                            {
                                (props.currentUser?.rol_id === 11 || props.currentUser?.rol_id === 14) ?
''
                                : (
                                    (label.code === '3' || label.code === '4') ?
                                        <div className={classes.contenedorPorSeccion}>
                                            <Typography variant="subtitle2" gutterBottom>{label.title+': '+label.total}</Typography>
                                        </div>
                                    : ''
                                )
                            }
                            </>
                        ))
                    )
                }
            </div>
            <AppBar position="static" color="inherit" elevation={0}>
                <Tabs 
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="on"
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="scrollable force tabs example"
                >
                    <Tab  label="Solicitudes Nuevas" icon={<LibraryAdd />} {...a11yProps(0)} />
                    <Tab label="Solicitudes Aprobadas" icon={<CheckCircleOutline />} {...a11yProps(1)} />
                    <Tab label="Solicitudes Rechazadas" icon={<HighlightOff />} {...a11yProps(2)} />
                    <Tab label="Solicitudes Casos Especiales" icon={<HighlightOff />} {...a11yProps(3)} />
                    <Tab label="Solicitudes TSE Virtual" icon={<Assignment />} {...a11yProps(4)} />
                    <Tab label="Solicitudes Con Inconsistencias" icon={<Assignment />} {...a11yProps(5)} />
                </Tabs>
            </AppBar>
            {/* Nuevas Solicitudes */}
            <TabPanel value={value} index={0} className={classes.backgroundColorTab}>
                <ListadoDeSolicitudesNuevas  authenticated={authenticated} currentUser={props.currentUser} ObtenerTotalDeSolicitudesPendientesDeRealizar={ObtenerTotalDeSolicitudesPendientesDeRealizar}/>
            </TabPanel>
            {/* Listado de solicitudes aprobadas */}
            <TabPanel value={value} index={1} className={classes.backgroundColorTab}>
                <ListadoDeSolicitudesAprobadas authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
            {/* Listado de solicitudes rechazadas */}
            <TabPanel value={value} index={2} className={classes.backgroundColorTab}>
                <ListadoDeSolicitudesRechazadas authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
            {/* Listado de solicitudes de casos especiales */}
            <TabPanel value={value} index={3} className={classes.backgroundColorTab}>
                <ListadoDeSolicitudesCasosEspeciales authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
            {/* Listado de solicitudes de TSE Virtual */}
            <TabPanel value={value} index={4} className={classes.backgroundColorTab}>
                <ListadoDeSolicitudesTSEVirtual authenticated={authenticated} currentUser={props.currentUser} ObtenerTotalDeSolicitudesPendientesDeRealizar={ObtenerTotalDeSolicitudesPendientesDeRealizar}/>
            </TabPanel>
            {/* Listado de solicitudes reportados a informatica "inconsistencias" */}
            <TabPanel value={value} index={5} className={classes.backgroundColorTab}>
                <ListadoDesolicitudesReportadosAInformaticaInconsistencias authenticated={authenticated} currentUser={props.currentUser}/>
            </TabPanel>
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(ScrollableTabsButtonForce);